import ReactJson from 'react-json-view';

import { useColorScheme } from '@/hooks/useColorScheme';

export const JsonView = (props: { json: object }) => {
  const { isDarkMode } = useColorScheme();
  return (
    <div className="text-sm [&_*]:!border-l-transparent [&_.icon-container]:translate-y-1">
      {typeof props.json !== 'object' ? (
        <pre>{JSON.stringify(props.json, null, 2)}</pre>
      ) : (
        <ReactJson
          src={props.json}
          name={false}
          iconStyle="square"
          style={{ background: 'transparent' }}
          theme={isDarkMode ? 'summerfruit' : 'rjv-default'}
          enableClipboard={false}
          indentWidth={2}
          collapsed={3}
          displayDataTypes={false}
          displayObjectSize={false}
          quotesOnKeys={false}
        />
      )}
    </div>
  );
};
